import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from './components/layout/MainLayout'

const Inicio = lazy(() => import('./pages/Inicio'))
const Servicios = lazy(() => import('./pages/Servicios'))
const QuienesSomos = lazy(() => import('./pages/QuienesSomos'))
const Contacto = lazy(() => import('./pages/Contacto'))
const Tienda = lazy(() => import('./pages/Tienda'))

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[60vh]">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-crg-mid"></div>
  </div>
)

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Inicio />} />
          <Route path="servicios" element={<Servicios />} />
          <Route path="nosotros" element={<QuienesSomos />} />
          <Route path="contacto" element={<Contacto />} />
          <Route path="tienda" element={<Tienda />} />
        </Route>
      </Routes>
    </Suspense>
  )
}